const translator = [
    // 默认进入的个人主页：所以，路由用其名字表示，例如译问个人主页路由
    {
        path: "index",
        name:"translator_index",
        component:()=>import('@/views/translator/index'),
        meta:{title: "个人主页", pageName: true, active:"index"}
    },
    {
        path: "material",
        name:"translator_material",
        component:()=>import('@/views/translator/material'),
        meta:{title: "个人资料", pageName: true, active: "material"}
    },
    // {
    //     path: "translation_job",
    //     name:"translation_job",
    //     redirect: '/translator/translation_job/got_job',
    //     component:()=>import("@/layouts/translation_job"),
    //     children:[
    //         {
    //             path: "got_job",
    //             name:"got_job",
    //             component:()=>import('@/views/translator/translation_job/got_job'),
    //             meta:{title: "待接收翻译任务", pageName: true}
    //         },
    //         {
    //             path: "submit_job",
    //             name:"submit_job",
    //             component:()=>import('@/views/translator/translation_job/submit_job'),
    //             meta:{title: "待完成翻译任务", pageName: true}
    //         }
    //     ]
    // },
    // {
    //     path: "review_job",
    //     name:"review_job",
    //     redirect: '/translator/review_job/job',
    //     component:()=>import("@/layouts/translation_job"),
    //     children:[
    //         {
    //             path: "job",
    //             name:"review_got_job",
    //             component:()=>import('@/views/translator/review_job/got_job'),
    //             meta:{title: "待接收审校任务", pageName: true}
    //         },
    //         {
    //             path: "submit_job",
    //             name:"review_submit_job",
    //             component:()=>import('@/views/translator/review_job/submit_job'),
    //             meta:{title: "待完成审校任务", pageName: true}
    //         }
    //     ]
    // },
    // {
    //     path: "work_record",
    //     name:"work_record",
    //     component:()=>import('@/views/translator/work_record'),
    //     meta:{title: "任务记录", pageName: true}
    // },
    // {
    //     path: "job_detail",
    //     name: "job_detail",
    //     component:()=>import('@/views/translator/job/detail'),
    //     meta: {title: "任务详情", pageName: true}
    // }

]

export default translator;